import AioExpressionParser from '@nsftx/sports-aio-expression-language-display-js-sdk';
import CryptoJS from 'crypto-js';
import SpecifierTypesCache from './specifier-types-cache';
import Supplemental from './supplemental';
const cache = new Map();
export default class ExpressionLanguage {
    label;
    supplementalToUse;
    event;
    market;
    outcome;
    key;
    constructor(label, options) {
        this.label = label ?? '';
        this.supplementalToUse = options.supplementalToUse;
        this.event = options.event;
        this.market = options.market;
        this.outcome = options.outcome ?? null;
        this.key = this.createCacheKey();
    }
    mapCompetitorsData = (competitors, pattern, fn) => {
        const match = this.label?.match(pattern) ?? null;
        if (!match)
            return [];
        const prefix = match[1];
        const suffix = /^[TP]$/.test(match[2]) ? `.${match[2]}` : '';
        return competitors.map((competitor) => `${prefix}.C${competitor.ordinal}${suffix}.NAME=${fn(this.supplementalToUse, competitor)}`);
    };
    mapSpecifiersData = (prefix, specifiers) => {
        const specifierTypes = new SpecifierTypesCache().getSpecifierTypes();
        return specifiers.map((specifier) => {
            const specifierType = specifierTypes.find(({ type }) => specifier.id === type);
            return `${prefix}.${specifierType?.name}=${specifier.value}`;
        });
    };
    createAntlrReadableVariables = () => {
        const supplemental = new Supplemental();
        const eventCompetitorsByName = this.mapCompetitorsData(this.event?.competitors, /(E)\.C\d+\.(NAME)/, supplemental.getCompetitorSupplementalName);
        const eventCompetitorsByTeamName = this.mapCompetitorsData(this.event?.competitors, /(E)\.C\d+\.(T)\.(NAME)/, supplemental.getCompetitorSupplementalTeamName);
        const eventCompetitorsByPlayerName = this.mapCompetitorsData(this.event?.competitors, /(E)\.C\d+\.(P)\.(NAME)/, supplemental.getCompetitorSupplementalPlayerName);
        const marketCompetitorsByName = this.mapCompetitorsData(this.market.competitors, /(M)\.C\d+\.(NAME)/, supplemental.getCompetitorSupplementalName);
        const marketCompetitorsByTeamName = this.mapCompetitorsData(this.market.competitors, /(M)\.C\d+\.(T)\.(NAME)/, supplemental.getCompetitorSupplementalTeamName);
        const marketCompetitorsByPlayerName = this.mapCompetitorsData(this.market.competitors, /(M)\.C\d+\.(P)\.(NAME)/, supplemental.getCompetitorSupplementalPlayerName);
        const outcomeCompetitorsByTeamName = this.mapCompetitorsData(this.outcome?.competitors, /(O)\.C\d+\.(T)\.(NAME)/, supplemental.getCompetitorSupplementalTeamName);
        const outcomeCompetitorsByPlayerName = this.mapCompetitorsData(this.outcome?.competitors, /(O)\.C\d+\.(P)\.(NAME)/, supplemental.getCompetitorSupplementalPlayerName);
        const specifiers = (/(O\.S\.|M\.S\.)/.test(this.label) && [
            ...this.mapSpecifiersData('M.S', this.market?.specifiers ?? []),
            ...this.mapSpecifiersData('O.S', this.outcome?.specifiers ?? []),
        ]) ||
            [];
        return [
            ...eventCompetitorsByName,
            ...eventCompetitorsByTeamName,
            ...eventCompetitorsByPlayerName,
            ...marketCompetitorsByName,
            ...marketCompetitorsByTeamName,
            ...marketCompetitorsByPlayerName,
            ...outcomeCompetitorsByTeamName,
            ...outcomeCompetitorsByPlayerName,
            ...specifiers,
        ];
    };
    createCacheKey() {
        const secret = {
            label: this.label,
            event: {
                id: this.event?.id,
                competitors: this.event?.competitors ?? [],
            },
            market: {
                id: this.market?.id ?? null,
                competitors: this.market?.competitors ?? [],
                specifiers: this.market?.competitors ?? [],
            },
            outcome: {
                id: this.outcome?.id ?? null,
                competitors: this.outcome?.competitors ?? [],
                specifiers: this.outcome?.competitors ?? [],
            },
        };
        const key = JSON.stringify(secret);
        return CryptoJS.MD5(key).toString();
    }
    parseDisplayNameFormula = () => {
        if (cache.has(this.key))
            return cache.get(this.key);
        const variables = this.createAntlrReadableVariables();
        try {
            const output = new AioExpressionParser().calculateString(this.label, variables);
            cache.set(this.key, output);
            return output;
        }
        catch (error) {
            return (this.outcome && this.outcome.name) || this.market.name || '';
        }
    };
}
